import React, { ReactElement } from 'react'

import CurrencyDisplayFormat from './CurrencyDisplayFormat'
import MonetaryCallAssignments from './MonetaryCallAssignments'
import { CurrencyDisplayFormatSettings, MonetaryCallAssignmentsValues } from '../Types'
// CSS imports. Commented out because of current build process.
// import './financialTab.scss'

/**
 * Component properties type.
 */
type Props = {
    currencyDisplayFormatSettings: CurrencyDisplayFormatSettings
    handleCurrencyDisplayFormatSettingsChange: (newCurrencyDisplayFormatSettings: CurrencyDisplayFormatSettings) => void
    monetaryCallAssignmentsValues: MonetaryCallAssignmentsValues
    setMonetaryCallAssignmentsValues: React.Dispatch<React.SetStateAction<MonetaryCallAssignmentsValues>>
    currencyFormatter: CDecimalFormatter
    supportsFinancialStatsInbound: boolean
    supportsFinancialStatsOutbound: boolean
}

/**
 * Financial tab of report configuration modal window.
 * @param currencyDisplayFormatSettings Object containing all currency formatting settings.
 * @param handleCurrencyDisplayFormatSettingsChange Handler method for changes to currencyDisplayFormatSettings.
 * @param monetaryCallAssignmentsValues Object containing all values for Monetary Call Assignments.
 * @param setMonetaryCallAssignmentsValues Setter for respective property.
 * @param currencyFormatter Instance of currency formatter to be used when formatting / parsing financial values.
 * @param supportsFinancialStatsInbound Report definition property.
 * @param supportsFinancialStatsOutbound Report definition property.
 */
const FinancialTab: React.FC<Props> = ({
    currencyDisplayFormatSettings,
    handleCurrencyDisplayFormatSettingsChange,
    monetaryCallAssignmentsValues,
    setMonetaryCallAssignmentsValues,
    currencyFormatter,
    supportsFinancialStatsInbound,
    supportsFinancialStatsOutbound
}: Props): ReactElement => {
    const previewValueUnformatted = 10000.21 // Unformatted constant for preview.

    const previewValue = currencyFormatter.Format(previewValueUnformatted)

    return (
        <div className='financial-tab tab-area'>
            <MonetaryCallAssignments
                monetaryCallAssignmentsValues={monetaryCallAssignmentsValues}
                setMonetaryCallAssignmentsValues={setMonetaryCallAssignmentsValues}
                supportsFinancialStatsInbound={supportsFinancialStatsInbound}
                supportsFinancialStatsOutbound={supportsFinancialStatsOutbound}
            />
            <CurrencyDisplayFormat
                currencyDisplayFormatSettings={currencyDisplayFormatSettings}
                handleCurrencyDisplayFormatSettingsChange={handleCurrencyDisplayFormatSettingsChange}
                previewValue={previewValue}
            />
        </div>
    )
}

export default FinancialTab
